import axios from "../axios";

const createWithdrawTransfer = async function (accessToken,params = {}) {
    try {
        const response = await axios.post('admin/withdraw-transaction/createWithdrawTransfer', params,{
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default createWithdrawTransfer;
